import http from '../utils/http';

// 用户
const role = {
    /**
     * 权限-角色-列表
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#203
     * @param {Object} options
     * @param {Number} options.departmentId 部门id
     * @param {Number} options.pageNum 分页-页码
     * @param {Number} options.pageSize 分页-每页条数
     * @param {String} options.roleName 角色名称
     * @param {Number} options.status 启用、禁用（1：启用；0：禁用）
     * @returns Promise
     */
    roleList(options) {
        return http.post('/role/list', options)
    },

    /**
     * 权限-角色——已启用角色
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#196
     * @param {Object} options
     * @returns Promise
     */
    listRoleSelect(options={},config={}) {
        return http.post('/role/listRoleSelect', options,{
            ...config
        })
    },

    /**
     * 权限-角色-终端组-树形结构
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#203
     * @param {Object} options
     * @param {Number} options.roleId 橘色id
     * @returns Promise
     */
    roletree(options={},config={}){
        return http.post('/devicegroup/roletree',options,{
            ...config
        })
    },

    /**
     * 权限-角色-菜单-树形结构
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#203
     * @param {Object} options
     * @param {Number} options.roleId 橘色id
     * @returns Promise
     */
    listRoleModule(options={},config={}){
        return http.post('/module/listRoleModule',options,{
            ...config
        })
    },

    /**
     * 权限-角色-添加
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#203
     * @param {Object} options
     * @param {Number} options.roleDesc 角色描述
     * @param {Number} options.roleName 角色名称
     * @param {Number} options.status 角色状态
     * @param {String} options.departmentId 部门ID
     * @returns Promise
     */
    save(options={},config={}) {
        return http.post('/role/save', options,{
            ...config
        })
    },
    /**
     * 权限-角色-修改
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#203
     * @param {Object} options
     * @param {Number} options.roleDesc 角色描述
     * @param {Number} options.roleName 角色名称
     * @param {Number} options.status 角色状态
     * @param {String} options.departmentId 部门ID
     * @param {String} options.roleId 角色ID
     * @returns Promise
     */
    update(options={},config={}) {
        return http.post('/role/update', options,{
            ...config
        })
    },
    /**
     * 权限-角色-更改状态
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#203
     * @param {Object} options
     * @param {Number} options.status 角色状态
     * @param {String} options.roleId 角色ID
     * @returns Promise
     */
    enableDisableRole(options) {
        return http.post('/role/enableDisableRole', options)
    },

    /**
     * 权限-角色-删除
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#203
     * @param {Object} options
     * @param {String} options.roleId 角色ID
     * @returns Promise
     */
    delete(options) {
        return http.post('/role/delete', options)
    },

}

export default role;
